var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap-box"},[_c('div',{staticClass:"top"},[_c('el-header',{staticClass:"top-header"},[_c('div',{staticClass:"header-content"},[_c('h3',{staticClass:"header-content-title"},[_vm._v("代码管理  ")])])]),_vm._v(" "),_c('cs-code-management')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3287996","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/CsCodeManagement.vue
// module id = Ur1P
// module chunks = 1